import moment from 'moment'
import {DATE_RANGE, getItem, setItem} from '../helpers/config'
import chart from './chart'

const getDateRange = () => (
    getItem(DATE_RANGE)
)

const setDateRange = (dateRange) => {
    setItem(dateRange || [], DATE_RANGE)
}

const mapDateRangeToTimeDimensions = (dashboardItem, dateRange, timeColumn) => {
    let vizState = JSON.parse(dashboardItem.vizState)
    let tableName = chart.getTableName(dashboardItem.id)
    let timeDimensions = vizState.query.timeDimensions
    let dateRangeAttr = !!dateRange && dateRange.length > 0 ?
        {
            dateRange: dateRange.map(value => moment(value).format('YYYY-MM-DD'))
        } :
        {}
    let updatedTimeDimensions
    if (!!timeDimensions && timeDimensions.length > 0) {
        updatedTimeDimensions = timeDimensions.map(timeDimension => {
            return {
                ...timeDimension,
                ...dateRangeAttr
            }
        })
    } else {
        updatedTimeDimensions = [{
            dimension: `${tableName}.${timeColumn}`,
            ...dateRangeAttr
        }]
    }

    return updatedTimeDimensions
}

/**
 * translate time dimensions from Cube JS into date range array 
 * @exports
 * @function mapTimeDimensionsToDateRange
 * @param {Object} dashboardItem the dashboard item
 * @returns {Array} the date range in the format [ 'YYYY-MM-DD', 'YYYY-MM-DD' ]
 */
const mapTimeDimensionsToDateRange = (dashboardItem) => {
    // parse of the cube js time dimensions
    let timeDimensions = JSON.parse(dashboardItem.vizState).query.timeDimensions
    let dateRange
    if (
        timeDimensions !== undefined &&
        timeDimensions.length > 0 &&
        timeDimensions[0].dateRange !== undefined
    ) {
        // if there is an existing dateRange, map it to array format 
        dateRange = timeDimensions[0].dateRange
            .map((date) => {
                return moment(date)
            })
    }
    return dateRange
}


/**
 * If the string is a timestamp, convert it to DD MMM format
 * @function getTimeIfValid
 * @param {String} data
 * @return {String} 
 */
const getTimeIfValid = (data) => {
    return (moment(data).toDate().toString() !== "Invalid Date") ?
        moment(data).format('DD-MMM') :
        data
}

/**
 * convert timestamp axis labels to DD MMM format
 * @exports
 * @function formatTimeStrings 
 * @param {Array} dataSet 
 * @returns {Array} updatedPivot where the timestamps are converted to DD MMM
 */
const formatTimeStrings = (dataSet) => {
    return dataSet.map((item) => {
        let updatedX = item.xValues.map((x) => {
            return getTimeIfValid(x)
        })
        return {
            ...item,
            category: getTimeIfValid(item.category),
            x: getTimeIfValid(item.x),
            xValues: updatedX
        }
    })
}

export default {
    getDateRange,
    setDateRange,
    mapDateRangeToTimeDimensions,
    formatTimeStrings,
    mapTimeDimensionsToDateRange
}